/* ============================================================
   Editorial block — lazy-load video.

   Walks every <video data-zc-lazy-video> on the page, attaches an
   IntersectionObserver (rootMargin 200px so the load starts before
   the viewport reaches it), and on first intersection:
     - injects a <source> tag built from data-video-src
     - calls .load() + .play()
     - unobserves itself (one-shot per node)

   The <video> element is display:none below 768px via CSS, so it
   has no bounding box on phones and the observer never fires for
   it. Zero mp4 download on mobile. The <img class="…__video-poster">
   covers the visual slot instead.

   Vanilla JS, no dependencies. Silent on browsers without
   IntersectionObserver (the video simply stays empty — acceptable
   degradation for IE11 / very old Safari).
   ============================================================ */
(function () {
  'use strict';

  const videos = document.querySelectorAll('[data-zc-lazy-video]');
  if (!videos.length) return;
  if (typeof IntersectionObserver === 'undefined') return;

  const io = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        const video = entry.target;
        const src = video.dataset.videoSrc;
        if (!src) {
          observer.unobserve(video);
          return;
        }
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.load();
        const playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(function () {
            // Autoplay refused — rare with muted+playsinline already
            // on the element. Stay silent, the poster covers the slot.
          });
        }
        observer.unobserve(video);
      });
    },
    { rootMargin: '200px' }
  );

  videos.forEach(function (video) {
    io.observe(video);
  });
})();
